import React, { useContext } from "react";
import { GameContext } from '../context/GameContext';

const TrophyRoom: React.FC = () => {
  const { purchasedItems } = useContext(GameContext)!; // Use context
  // Calculate width based on height to maintain 4299/1080 aspect ratio
  const aspectRatio = 4299/1080;
  
  return (
    <div className="h-screen w-full overflow-x-auto overflow-y-hidden">
      <div 
        className="h-full relative"
        style={{
          width: `${100 * aspectRatio}vh`, // This will maintain the aspect ratio
          minWidth: '960px',
          backgroundImage: "url('/images/trophyRoom.png')",
          backgroundSize: '100% 100%', // This ensures the image covers the exact dimensions
          backgroundRepeat: 'no-repeat',
        }}
      >

        {/* Overlay Component - Modified to show fixed 4 slots */}
        <div
          className="absolute bg-transparent rounded"
          style={{
            top: '20%',           // Position from the top
            left: '4%',          // Center horizontally
            width: '200px',       // Small width for the overlay
            height: '76vh',       // Almost full height
            padding: '10px',
          }}
        >
          {/* Purchased Items Container */}
          <div className="flex flex-col items-center gap-4">
            {purchasedItems.map(item => (
                  <img 
                key={item.id}
                src={item.image}
                alt={item.name}
                className="w-24 h-24 object-contain"
                style={{
                  // Systematic positioning handled by Flexbox
                }}
              />
            ))}
          </div>
        </div>
        {/* End of Overlay Component */}

        {/* Your trophy room content goes here */}
      </div>
    </div>
  );
}

export default TrophyRoom;